import React, { Suspense, lazy, useEffect } from "react";
import { LoadingSpinner } from "./components/LoadingSpinner";
import { AuthProvider } from "./contexts/AuthContext";
import WebSocketManager from './services/WebSocketManager';
import { Toaster } from "@/components/ui/toaster";
import { useAnalytics } from '@/hooks/useAnalytics';
// Remove direct route imports if Routing.jsx handles them
// import { Routes, Route } from "react-router-dom"; 
// import Library from "./pages/Library";
// import Explore from "./pages/Explore";
// import SoundEffects from "./pages/SoundEffects";
// import ImageToVideo from "./pages/ImageToVideo";
// import SingleImageToVideo from "./pages/SingleImageToVideo";
// import Sidebar from "./components/app-sidebar"; 

const Routing = lazy(() => import("./utils/Routing")); // Restore lazy load

function App() {
  const analytics = useAnalytics();
  
  useEffect(() => {
    return () => {
      WebSocketManager.getInstance().cleanupAll();
    };
  }, []);

  // Track initial page view
  useEffect(() => {
    analytics.trackEvent('app_loaded', {
      timestamp: new Date().toISOString()
    });
  }, []);

  return (
    <AuthProvider>
      {/* Restore original structure: Let Routing handle layout and Routes */}
      <div className="w-full bg-[#08090A] h-full text-white">
        <Suspense fallback={<LoadingSpinner />}>
          <Routing />
        </Suspense>
        <Toaster />
      </div>
    </AuthProvider>
  );
}

export default App;
